import isDev from "~/utils/is-dev"

export const soClozDomain = isDev ? `https://api.testing-j.sandbox.socloz.com` : `https://api.socloz.com/`

export const soClozCssClassName = "socloz"
